import { useTranslation } from 'react-i18next'
import Alert from '@mui/material/Alert'
import Box from '@mui/material/Box'
import Collapse from '@mui/material/Collapse'
import { FormikButtons } from 'components/Formik/FormikButtons'
import { FormikTextField } from 'components/Formik/FormikTextField'
import { FieldsExtended } from 'components/JSONForm/types'
import { Form, Formik } from 'formik'
import { FieldNames } from 'pages/Login/api/useGetActivationCodeForm'
import { useGetRegistrationFormByEmail } from 'pages/Login/RegisterAccount/hooks/useGetRegistrationFormByEmail'
import { parseError } from 'utils/api/parseError'
import * as Yup from 'yup'

type Props = {
  onSuccess: (data: { fields: FieldsExtended<FieldNames>; personal_id_hint: any } & { email?: string }) => void
  onBack?: () => void
  disabled?: boolean
  email?: string
}

export const EnterEmail = ({ onSuccess, disabled, email, onBack }: Props) => {
  const { mutate, error, variables, isLoading, isError } = useGetRegistrationFormByEmail()
  const { t } = useTranslation()

  const initialValues = {
    email: email || '',
  }

  const validationSchema = Yup.object().shape({
    email: Yup.string().label(t('auth.activate_account.field.email')).notRequired().nullable(),
  })

  const onSubmit = (values: typeof initialValues) => {
    mutate({ email: values.email, onSuccess })
  }
  const parsedError = parseError(error)
  const isVisibleError = () => parsedError?.message && !isLoading && isError

  return (
    <Formik initialValues={initialValues} enableReinitialize validationSchema={validationSchema} onSubmit={onSubmit}>
      <Form>
        <Box display="grid" gridTemplateColumns="minmax(auto, 500px)" justifyContent="center">
          <FormikTextField
            inputLabel={'auth.activate_account.field.email'}
            name="email"
            disabled={disabled}
            size="small"
          />
          <Collapse in={isVisibleError()}>
            <Alert severity="error" sx={{ borderRadius: 24, mt: 2 }}>
              {parsedError?.message || t('auth.activate_account.incorrect_email')}
            </Alert>
          </Collapse>
        </Box>
        <Box mt={2}>
          <FormikButtons onBack={onBack} textButtonSubmit="app.next" />
        </Box>
      </Form>
    </Formik>
  )
}
